import React from "react";

export const MovieInfoItem = ({ movie }) => {
  return (
    <>
      <li className="movieListItem pointerCursor" key={movie.imdbID}>
        <img src={movie.Poster} alt={`${movie.Title} poster`} />
        <h3>{movie.Title}</h3>
        <div>
          <p>
            <span>🗓</span>
            <span>{movie.Year}</span>
          </p>
        </div>
      </li>
    </>
  );
};

export default MovieInfoItem;
